import { Modal } from "antd"
import { useRemoveGroupMember } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { GroupMemberWithRelationsDto } from "@mimber/schema"

export interface ShowRemoveGroupMemberModalOptions {
  member: GroupMemberWithRelationsDto
  groupUuid?: string
  onConfirm: () => void
}

export const useRemoveGroupMemberModal = () => {
  const [modal, contextHolder] = Modal.useModal()
  const removeMember = useRemoveGroupMember()

  const showRemoveGroupMemberModal = ({
    member,
    groupUuid,
    onConfirm,
  }: ShowRemoveGroupMemberModalOptions): void => {
    const memberDisplayName = member.membership.user.displayName
      ? member.membership.user.displayName
      : [member.membership.user.firstName, member.membership.user.lastName]
          .filter(Boolean)
          .join(" ") || member.membership.user.email

    const resolvedGroupUuid = groupUuid || member.group?.uuid

    if (!resolvedGroupUuid) {
      message.error("Unable to remove member from this group")
      return
    }

    modal.confirm({
      title: "Remove Member",
      content: `Are you sure you want to remove ${memberDisplayName} from this group? This action cannot be undone.`,
      okText: "Remove",
      okType: "danger",
      cancelText: "Cancel",
      okButtonProps: { loading: removeMember.isPending },
      onOk: () => {
        removeMember.mutate(
          {
            groupUuid: resolvedGroupUuid,
            memberUuid: member.uuid,
          },
          {
            onSuccess: () => {
              message.success("Member removed from group successfully")
              onConfirm()
            },
            onError: (error) => {
              message.error(error.message || "Failed to remove member")
            },
          }
        )
      },
    })
  }

  return {
    contextHolder,
    showRemoveGroupMemberModal,
  }
}
